import type { ComponentProps } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { FullscreenAlert, PhoneIcon } from "@/shared/ui";

export const WhiteCoatSyncModal = ({
  open,
  onOpenChange,
}: ComponentProps<typeof FullscreenAlert.Root>) => {
  const navigate = useNavigate();

  const handleClose = () => {
    void navigate(ROUTES.HOME);
  };

  return (
    <FullscreenAlert.Root open={open} onOpenChange={onOpenChange}>
      <FullscreenAlert.Content theme="light">
        <FullscreenAlert.Header icon={PhoneIcon}>
          <FullscreenAlert.Title>
            {t`Phone consultation required`}
          </FullscreenAlert.Title>

          <FullscreenAlert.Description>
            {t`Based on your state's requirements, a phone consultation is required before starting treatment. After you submit your intake form, you'll receive a call from one of our providers to complete your visit. Keep an eye out - we'll be in touch soon!`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Action onClick={handleClose}>
            {t`Back to Home`}
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
